import { render, staticRenderFns } from "./DdAutocompleteChipBox.vue?vue&type=template&id=078127c6&scoped=true&"
import script from "./DdAutocompleteChipBox.vue?vue&type=script&lang=js&"
export * from "./DdAutocompleteChipBox.vue?vue&type=script&lang=js&"
import style0 from "./DdAutocompleteChipBox.vue?vue&type=style&index=0&id=078127c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "078127c6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAutocomplete,VRow,VTooltip})
